// extracted by mini-css-extract-plugin
module.exports = {"card":"inviteUsers_card__1fZ5Q"};